import {
    trackPageView,
    trackCheckoutStep,
    trackCustomEvent,
    trackTransaction,
    trackProductView,
    trackProductImpression,
    trackProductClick,
    trackAddToCart,
    trackRemoveFromCart,
    trackCheckoutOption,
    trackPurchase,
} from "./tracking.actions";
import { IStoreState } from "@montana/store/store";
import { generateContainer } from "../base/generate-container";

const mapState = (s: IStoreState) => s.tracking;

const actions = {
    trackPageView,
    trackCheckoutStep,
    trackCustomEvent,
    trackTransaction,
    trackProductView,
    trackProductImpression,
    trackProductClick,
    trackAddToCart,
    trackRemoveFromCart,
    trackCheckoutOption,
    trackPurchase,
};

export const [TrackingContainer, connectWithTracking, useTracking] = generateContainer(mapState, actions);
